module.exports = __webpack_public_path__ + "img/dhfesta_logo-2.4e114fde.png";